import { render, staticRenderFns } from "./WeightPlant.vue?vue&type=template&id=485f1b60"
import script from "./WeightPlant.vue?vue&type=script&lang=js"
export * from "./WeightPlant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports